// LIBRERIE/IMPORTS
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

// LIBRERIE ESTERNE
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleDown } from "@fortawesome/free-regular-svg-icons";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";

// CONFIGURAZIONI
import { AGENCY_ID } from "../../../config/appConfig";

// COMPONENTI
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import SlowLoadComponent from "../../Error/SlowLoadComponent";
import PropertySearchField from "../../Home/Search";
import NotFound from "../../Error/NotFound";

// STILI X SLINK
import heroCarouselSyle from "../../../assets/jsStyle/heroCarouselStyle";

interface SubHeaderHomeProps {
    agencyName?: string;
    isSeo: boolean;
    showSearchForm?: boolean;
}

const SubHeaderHome: React.FC<SubHeaderHomeProps> = ({
    showSearchForm = false /* Default a true se non specificato*/ }) => {

    const { agency, loading, error } = useGetAgencyDetails(AGENCY_ID);
    const { t } = useTranslation();

    const carouselImages = [
        {src: "/assets/images/inHome/heroCarousel/salone.webp", alt: t('homePage.carouselImage1Alt')},
        {src: "/assets/images/inHome/heroCarousel/terrazza.webp", alt: t('homePage.carouselImage2Alt')},
        {src: "/assets/images/inHome/heroCarousel/camera.webp", alt: t('homePage.carouselImage3Alt')},
    ]

    // Transizione per rendere visibile il text wrapper
    const [boxVisible, setBoxVisible] = useState(false);

    useEffect(() => {
        const handleVisible = () => {
            setBoxVisible(true)
        };

        const timer = setTimeout(handleVisible, 4500);
        return () => clearTimeout(timer);
    }, [])

    // Rendering Componente
    if (loading) return <LoadingIndicator />;
    if (error) return <SlowLoadComponent />;
    if (!agency) return <NotFound message={`${t('common.agencyNotFound')}`} />;

    return (
        <section className="banner bg-overlay-white-20">

            { /* Attiva Carosello */}
            {false && (
                <Slider {...heroCarouselSyle}>
                    {carouselImages.map((image, index) => (
                        <div key={index}>
                            <img src={image.src} alt={image.alt} className="carousel-image" />
                        </div>
                    ))}
                </Slider>
            )}

            { /* Attiva box a comparsa + form ricerca (Se attivo in Banner) */}
            <div className="container-fluid">
                <div className={`text-wrapper ${boxVisible ? 'visible' : ''}`}>
                    <img src="/assets/images/logo.png" alt={t('homePage.hero.imgAlt') as string} />
                    {showSearchForm && <PropertySearchField searchData={{}} />}
                </div>
            </div>

            {/* Attiva l'indicatore di scroll */}
            <div className="scroll-indicator">
                <a href="#vetrina2-box" title="Scroll">
                    <FontAwesomeIcon icon={faCircleDown} />
                </a>
            </div>

            <div className="btn-wrapper d-none d-md-block">
                <Link to="/immobili" className="btn btn-primary">{t('homePage.presentation.textButton')}</Link>
            </div>
        </section>
    );
};

export default SubHeaderHome;